export default __webpack_public_path__ + "static/what-to-do-in-japan-timing-it-right-himeji-castle-203e48aaa3c86bd3cda2cad9012b3420.jpg";